import { render, staticRenderFns } from "./CustomerAgingSummaryBarChart.vue?vue&type=template&id=362f5810"
import script from "./CustomerAgingSummaryBarChart.vue?vue&type=script&lang=ts"
export * from "./CustomerAgingSummaryBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports